import styled from "styled-components"

export const StyledEmailInput = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 8px 8px 8px 12px;
  align-items: center;
  gap: 10px;
  border-radius: 12px;
  border: 1.5px solid var(--black-black-6-s-10-l-94, #f0f0ef);
  background: var(--white-white-1, #fff);
`

export const StyledEmailTextInput = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background: #fff;
  font-family: Source Sans Pro;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
   -webkit-box-shadow: 0 0 0 30px white inset !important;
  &::placeholder {
    color: #0D0D0D;
    opacity: 0.4;
  }
`
